import '../../components/styles/PharmacovigilanceCommittee.css';
import '../../components/styles/CommitteeTable.css';

const GenderHarassment = () => {
  const members = [
    { sl: 1, name: 'Dr. Arthy', designation: 'Associate Professor of Forensic Medicine & Toxicology', position: 'Chairperson', mobile: '8447662259', email: 'arthy2712@gmail.com' },
    { sl: 2, name: 'Dr. A. Rajalakshmi', designation: 'Associate Professor of Anatomy', position: 'Member', mobile: '7639985320', email: 'avhariraj@gmail.com' },
    { sl: 3, name: 'Dr. Divyabharathy. R', designation: 'Assistant Professor of Community Medicine', position: 'Member', mobile: '7094344720', email: 'drdivyabharathy@gmail.com' },
    { sl: 4, name: 'Dr. Aljin Jino. M', designation: 'Assistant Professor of Psychiatry', position: 'Member', mobile: '9487775991', email: 'jino.aljin@gmail.com' },
    { sl: 5, name: 'Ms. Fatima', designation: 'NGO', position: 'Member', mobile: '9500507988', email: 'fatima@gmail.com' },
    { sl: 6, name: 'Mrs. G.D. Vijayalakshmi', designation: 'Assistant Admin Manager, Dean Office', position: 'Member', mobile: '9655386385', email: 'vijayalakshmiiswin@gmail.com' },
    { sl: 7, name: 'Ms. Yogita', designation: 'I Year MBBS Student', position: 'Member', mobile: '7904284220', email: 'saiyogita06@gmail.com' },
    { sl: 8, name: 'Mrs. Usha. A', designation: 'Accountant, MS Office', position: 'Secretary', mobile: '8072600094', email: 'usharajakumari90@gmail.com' },
  ];

  const pdfPath = '/assets/document/committee/ic-committee/IC Commitee.pdf';

  return (
    <div className="pharma-container">
      <header className="pharma-header">
        <h1>Internal Complaints & Gender Harassment Prevention Committee</h1>
      </header>

      <section className="pharma-description">
        <p>
          The Internal Complaints and Gender Harassment Prevention Committee (Reconstituted) ensures
          a work and academic environment free from gender-based discrimination or misconduct.
          It provides support to affected individuals and takes necessary actions to ensure
          justice and safety for all members of the institution.
        </p>
      </section>

      <section className="pharma-table-section">
        <div className="ct-table-wrapper">
          <table className="pharma-table ct-table">
            <thead>
              <tr>
                <th>Sl. No.</th>
                <th>Name</th>
                <th>Designation</th>
                <th>Position</th>
                <th>Mobile No.</th>
                <th>Email ID</th>
              </tr>
            </thead>
            <tbody>
              {members.map((m) => (
                <tr key={m.sl}>
                  <td className="ct-sl" data-label="Sl.">{m.sl}</td>
                  <td data-label="Name">{m.name}</td>
                  <td data-label="Designation">{m.designation}</td>
                  <td data-label="Position">{m.position}</td>
                  <td className="ct-nowrap" data-label="Mobile">{m.mobile}</td>
                  <td className="ct-email" data-label="Email">{m.email}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <div className="ct-doc-btn-wrap">
        <a href={`/view-document.html?file=${encodeURIComponent(pdfPath)}`} target="_blank" rel="noopener noreferrer" className="ct-doc-btn">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="12" y1="18" x2="12" y2="12"/>
            <line x1="9" y1="15" x2="15" y2="15"/>
          </svg>
          View Official Document
        </a>
      </div>
    </div>
  );
};

export default GenderHarassment;
